<template>
  <div>
    <div v-if="$i18n.locale === 'cl' || $i18n.locale === 'pe'">
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <div v-if="userIsBroker" style="padding-top: 20px;" />
      <b-field v-if="selectedView && !userIsBroker" class="radio-buttons-container">
        <b-field>
          <b-radio-button
            v-model="selectedView"
            class="radio-button"
            :class="selectedView === 'Leads' && 'radio-button-selected'"
            data-cy="button-lead"
            native-value="Leads">
            <i class="fa-solid fa-user-group" />
            <h3>Leads</h3>
          </b-radio-button>
          <b-radio-button
            v-model="selectedView"
            class="radio-button"
            :class="selectedView === 'Brokers' && 'radio-button-selected'"
            data-cy="button-broker"
            native-value="Brokers">
            <i class="fa-solid fa-user-tie" />
            <h3>Brokers</h3>
          </b-radio-button>
        </b-field>
      </b-field>

      <div v-if="selectedView === 'Leads'"><Leads /></div>
      <div v-if="selectedView === 'Brokers'"><Brokers :user-is-broker="userIsBroker" /></div>
    </div>
  </div>
</template>

<script>
import Message from '@/ui/components/Message.vue';
import { getBrokerByEmail } from '@/application/services/api-clients/brokers';
import Leads from '../leads/Leads.vue';
import Brokers from '../brokers/Brokers.vue';

export default {
  name: 'CommercialManager',
  components: { Brokers, Leads, Message },
  data() {
    return {
      userIsBroker: false,
      brokerIsMultiple: false,
      selectedView: null
    };
  },
  mounted() {
    this.loadBroker();
  },
  methods: {
    async loadBroker() {
      const { email } = this.$store.state.currentUser.user;
      const { brokerList } = await getBrokerByEmail(email);
      if (brokerList && brokerList.length > 0) {
        this.userIsBroker = true;
        this.brokerIsMultiple = brokerList.length > 1;
      }
      if (this.userIsBroker) {
        if (this.brokerIsMultiple) {
          this.selectedView = 'Brokers';
        } else {
          const { _id: brokerId } = brokerList[0];
          this.$store.state.brokersModule.brokerIsMultiple = this.brokerIsMultiple;
          this.$store.state.brokersModule.userIsBroker = this.userIsBroker;
          this.$router.push(`broker/${brokerId}`);
        }
      } else { this.selectedView = 'Leads'; }
    }
  }
};
</script>

<style scoped>
.font-size {
  color: var(--color-nickel);
  font-size: 1.5rem;
  font-weight: 300;
  margin: 10px 0px;
}
.radio-buttons-container {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
  margin: 2rem 0;
}
.radio-button i {
  color: var(--primary);
}
.radio-button h3 {
  color: var(--primary);
  font-size: 1.3rem;
  margin-left: 5px;
}
.radio-button-selected h3,
.radio-button-selected i {
  color: #fff;
}
</style>
